// extracted by mini-css-extract-plugin
export default {"forgotPass":"ForgotPassword_forgotPass__Pfdut","logo":"ForgotPassword_logo__T9cuM"};